import { useNavigate } from 'react-router-dom'

import { Button } from './Button'

interface SkillBannerProps {
  name: string
  image: string
  description?: string
  id: string
}

export const SkillBanner = ({ name, description, image, id }: SkillBannerProps) => {
  const navigate = useNavigate()
  const navigateToSkill = (skillId: string) => {
    navigate(`/explore-learnings/skill/${skillId}`)
  }
  return (
    <div
      className="gradient-border w-[1120px] h-[150px] rounded-2xl hover:[box-shadow:0px_14px_24px_0px_#0000000F] transition-all cursor-pointer"
      onClick={() => navigateToSkill(id)}
    >
      <div className="flex m-[2px] mt-0 mx-auto bg-white w-[1116px] h-full rounded-[0.9rem] items-center">
        <div className="bg-[#F4F2EF] rounded-[16px] w-[200px] h-full flex justify-center items-center">
          <img src={image} alt={name} />
        </div>
        <div className="flex flex-col mx-[34px] w-[710px] h-[54px] font-TCCCText">
          <p className="pb-[6px] strong-m">{name}</p>
          <p className="body-s text-[#505050]">{description}</p>
        </div>
        <div className="mr-[46px]">
          <Button text="Explore" />
        </div>
      </div>
    </div>
  )
}
